const Routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { noNeedDefaultData: true },
    component: {
      render (c) {
        return c('router-view')
      }
    },
    redirect: '/login/',
    children: [
      {
        path: '/',
        name: 'login',
        component: () => import('@/app/authentication/views/Login')
      },
      {
        path: 'saml',
        name: 'samlLogin',
        meta: { noNeedDefaultData: true },
        component: () => import('@/app/authentication/views/SamlLogin')
      }
    ]
  },
  {
    path: '/auth',
    name: 'Authentication',
    meta: { noNeedDefaultData: true },
    component: {
      render (c) {
        return c('router-view')
      }
    },
    children: [
      {
        path: 'reset-password/:token',
        name: 'resetPassword',
        component: () => import('@/app/authentication/views/ResetPassword'),
        props: true
      },
      {
        path: 'request-new-password',
        name: 'requestNewPassword',
        component: () => import('@/app/authentication/views/RequestNewPassword')
      },
      {
        path: 'region-selection',
        name: 'regionSelection',
        component: () => import('@/app/authentication/views/RegionSelection'),
        props: true
      },
      {
        path: 'google-callback',
        name: 'googleCallback',
        meta: { noNeedDefaultData: true },
        component: () => import('@/app/authentication/views/SSOCallback.vue')
      },
      {
        path: 'microsoft-callback',
        name: 'microsoftCallback',
        meta: { noNeedDefaultData: true },
        component: () => import('@/app/authentication/views/SSOCallback.vue')
      }
    ]
  },
  {
    path: '/saml-callback',
    name: 'samlCallback',
    meta: { noNeedDefaultData: true },
    component: () => import('@/app/authentication/views/SamlCallback.vue')
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/authentication/Routes.js